.edit-swimlane-in-desking-link {
  display: flex;
  align-items: center;
  margin-left: var(--rds-spacing--24);
  line-height: 1.5rem;
  white-space: nowrap;
  color: var(--rds-foreground-secondary);

  &:hover {
    color: var(--rds-foreground-primary);
  }
}
